import { gql, TypedDocumentNode } from "@apollo/client";

import { QueryMetricsRangeArgs, SpaceliftMetrics } from "types/generated";

type GetDeploymentFrequencyRangeData = {
  metricsRange: Pick<SpaceliftMetrics, "numberOfDeploymentsRange" | "hasRuns">;
};

export const GET_DEPLOYMENT_FREQUENCY_RANGE: TypedDocumentNode<
  GetDeploymentFrequencyRangeData,
  QueryMetricsRangeArgs
> = gql`
  query GetDeploymentFrequencyRange($input: MetricsInput) {
    metricsRange(input: $input) {
      numberOfDeploymentsRange {
        value
        timestamp
      }
      hasRuns
    }
  }
`;
